import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Repeat, Trash2, ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { serviceLabel } from "@/components/booking/constants";

export const RegularRuns = ({ refreshKey = 0 }) => {
  const navigate = useNavigate();
  const [runs, setRuns] = useState([]);
  useEffect(() => { api.get("/saved-runs").then((r) => setRuns(r.data)).catch(() => setRuns([])); }, [refreshKey]);
  const remove = async (id) => {
    try { await api.delete(`/saved-runs/${id}`); setRuns((p) => p.filter((r) => r.id !== id)); toast.success("Run removed"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  return (
    <Card className="mt-6 border-kilted-gold/40" data-testid="regular-runs-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg"><Repeat className="h-5 w-5 text-kilted-gold" /> Regular runs</CardTitle>
        <p className="text-sm text-muted-foreground">Tap "Book again" to rebook a saved run — same drop-off, items and service.</p>
      </CardHeader>
      <CardContent className="space-y-2">
        {runs.length === 0 && (
          <p className="text-sm text-muted-foreground" data-testid="regular-runs-empty">No saved runs yet — tap "Save run" on any courier job in your Courier jobs list.</p>
        )}
        {runs.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-border bg-white p-3" data-testid={`regular-run-${r.id}`}>
            <div className="min-w-0 flex-1">
              <p className="truncate font-semibold text-kilted-green">{r.name}</p>
              <p className="truncate text-xs text-muted-foreground">
                {r.dropoff.business ? `${r.dropoff.business} · ` : ""}{r.dropoff.line1}, {r.dropoff.city} · {(r.items || []).map((i) => `${i.quantity}× ${i.size}`).join(", ")} · {serviceLabel(r.service)}
              </p>
            </div>
            <Button size="sm" onClick={() => navigate("/book", { state: { rebook: r } })} data-testid={`regular-run-book-${r.id}`} className="gap-1.5 bg-kilted-green hover:bg-kilted-greenLight">
              Book again <ArrowRight className="h-3.5 w-3.5" />
            </Button>
            <Button size="icon" variant="ghost" onClick={() => remove(r.id)} data-testid={`regular-run-delete-${r.id}`} className="h-8 w-8 text-muted-foreground"><Trash2 className="h-4 w-4" /></Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
